function AdminCounterBidingTooltip() {
  return (
    <span>The admin counter bidding setting or Allow or Disable overrides the partner setting.</span>
  );
}

export default AdminCounterBidingTooltip;